// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2saLX","subheader":"ReorderModal_subheader__2Oa_s","listWrap":"ReorderModal_listWrap__27UDg"};